import React from 'react';
import './ProjectStyle.css'; // Shared CSS for all projects
import projectVideo from '../../Videos/OTUMSAWebsite.mp4';

const ProjectTemplate = () => {
  return (
    <div className="project-container">
        <div className="navbar-non-transparent"></div>
        <div className="title">
            <h1>Ontario Tech University Muslims Student Association (OTUMSA) Website</h1>
        </div>
      <div className="project-image-section">
        <video className="project-image" controls>
          <source src={projectVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="tools">
        <p><em><strong>Made with: HTML/CSS, Javascript, MongoDB, Express JS, Node JS, Cloudinary and Apache Servers</strong></em></p>
      </div>

        <div className="project-content">
            <section className="project-section">
                <h2>Overview</h2>
                <p>
                Leveraging my web development experience, I was approached by OTUMSA to create their official website. Given my 
                strong connections to the MSA, I took on the project, building a site that includes a directory of local mosques, 
                nearby halal restaurants, an events page, an FAQ section, and a contact form. The website is hosted on Ontario Tech 
                University’s servers using Apache and is live at https://otumsa.com/
                </p>
            </section>
        </div>

    </div>
  );
};

export default ProjectTemplate;
